import getParamFromUrl from './_getParamFromUrl';
import checkValue from './_checkValue';

/**
 * Update a value on an object with a value from URL.
 *
 * @param {Array} urlKeys - names of the URL parameters
 * @param {Object} urlParams - all search parameters in the current URL
 * @param {Object} saveTo - key/value pairs with the property/object where URL keys are saved
 *
 * @returns {Boolean}
 */
function setValueFromUrl(urlKeys, urlParams, saveTo) {
  const urlParam = getParamFromUrl(urlKeys, urlParams);
  let target, changed;

  for (const prop in saveTo) {
    target = saveTo[prop];
    const status = checkValue(target[prop], urlParam);
    target[prop] = status.value;

    changed = changed || status.changed;
  }

  return changed;
}

export default setValueFromUrl;
